var PROPS_TO_FILTER = ['changeHandler', 'dialingCode', 'dialingCodeLabel', 'dialingCodeStyleOverrides', 'inputStyleOverrides', 'withoutDialingCode', 'value'];
export { PROPS_TO_FILTER };